import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import useExpandable from 'Hooks/useExpandable';
import { selectCredentialDetail, getFormattedDate } from 'store/Credentials/selectors';
import { updateCredential } from 'store/Credentials/actions';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import Checkbox from 'Common/Components/Checkbox';
import { Wrapper, Row } from './styled';
import LinkedVulns from 'Screens/Credentials/components/CreateEditModal/components/LinkedVulns';
import { CheckBoxWrapper, Label, Password, TextField } from 'Screens/Credentials/components/CreateEditModal/styled';
import LeakDate from 'Screens/Credentials/components/CreateEditModal/components/LeakDate';

const ID = 'info';

const Info = () => {
  const credentialSelected = useSelector(selectCredentialDetail);

  const getCredential = (elem, defaultValue) => {
    if (elem === 'leak_date') {
      const leakDate = get(credentialSelected, 'leak_date', null);
      return getFormattedDate(leakDate);
    } else return get(credentialSelected, elem, defaultValue);
  };

  const [data, setData] = useState({
    username: getCredential('username', ''),
    owned: getCredential('owned', false),
    password: getCredential('password', ''),
    leakDate: getCredential('leak_date', null),
    endpoint: getCredential('endpoint', ''),
    vulnerabilities: getCredential('vulnerabilities', '')
  });

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'credentials.detail.info' });
  const dispatch = useDispatch();
  const isExpanded = useExpandable('general', ID, true);

  useEffect(() => {
    setData({
      username: getCredential('username', ''),
      owned: getCredential('owned', false),
      password: getCredential('password', false),
      leakDate: getCredential('leak_date', null),
      endpoint: getCredential('endpoint', ''),
      vulnerabilities: getCredential('vulnerabilities', '')
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentialSelected]);

  const onChangeInput = (field, value) => setData((prevData) => ({ ...prevData, [field]: value }));

  const updateField = (field, value) => {
    const requiredFields = ['username', 'password'];
    if (requiredFields.includes(field) && !value) {
      return null;
    } else {
      dispatch(updateCredential(credentialSelected, field, value));
    }
  };

  return (
    <ExpandableWrapper id={ ID } title={ title } defaultValue={ isExpanded } tab="general">
      <Wrapper>
        <Row>
          <TextField
            title={ intl.formatMessage({ id: 'credentials.modalCreateEdit.username' }) }
            autoComplete="new-credential-username"
            name="credential-username"
            id="credential-username"
            value={ data.username }
            onChange={ (value) => onChangeInput('username', value) }
            isRequired
            placeholder="example@email.com"
            onBlur={ () => updateField('username', data.username) }
          />
          <CheckBoxWrapper>
            <Checkbox checked={ data.owned } onChange={ () => dispatch(updateCredential(credentialSelected, 'owned', !data.owned)) } state={ data.owned } />
            <Label>Owned</Label>
          </CheckBoxWrapper>

        </Row>
        <Row>
          <Password
            title={ intl.formatMessage({ id: 'credentials.modalCreateEdit.password' }) }
            autocomplete="new-password"
            name="credential-password"
            id="credential-password"
            value={ data.password }
            onChange={ (value) => onChangeInput('password', value) }
            onBlur={ (value) => updateField('password', value) }
            type="password"
            placeholder="**********"
          />
          <LeakDate
            onChange={ (v) => updateField('leak_date', v) }
            title={ intl.formatMessage({ id: 'credentials.modalCreateEdit.leakDate' }) }
            value={ data.leakDate }
          />

        </Row>
        <TextField
          title={ intl.formatMessage({ id: 'credentials.modalCreateEdit.endpoint' }) }
          autoComplete="new-credential-client-endpoint"
          name="credential-client-endpoint"
          id="credential-client-endpoint"
          value={ data.endpoint }
          onChange={ (value) => onChangeInput('endpoint', value) }
          placeholder="https://myendpopint.com"
          onBlur={ () => dispatch(updateCredential(credentialSelected, 'endpoint', data.endpoint)) }
        />
        <LinkedVulns
          vulns={ data.vulnerabilities }
          setLinkedVuln={ (vulnerabilities) => dispatch(updateCredential(credentialSelected, 'vulnerabilities', vulnerabilities.map((vuln) => vuln.id))) }
          hideListShadow
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default Info;
